import { FC, ReactElement } from 'react';
import styled from 'styled-components';

const LoadingContent = styled.div`
    text-align: center;
    padding: 0.2rem 0;
    svg {
        display: inline-block;
        width: 0.35rem;
        height: 0.35rem;
        animation: rotate 2s linear infinite;
    }
`;

const NodataContent = styled.div`
    text-align: center;
    padding: 0.2rem 0;
    font-size: 0.16rem;
    color: #202046;
`;

interface Props {
    loading: boolean;
    nodata: boolean;
    children?: any
}

const Nodata: FC = (): ReactElement => <NodataContent>暂无数据</NodataContent>;

const LoadingMain: FC = (): ReactElement => (
    <LoadingContent>
        <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13617" width="26" height="26">
            <path d="M512 170.666667v85.333333a256 256 0 1 1-223.573333 131.2L213.930667 345.6A341.333333 341.333333 0 1 0 512 170.666667z" fill="#3a3a3a" p-id="13618"></path>
        </svg>
    </LoadingContent>
);

const Loading: FC<Props> = ({ loading, nodata, children }: Props): ReactElement => {
    const checkElement = () => {
        if(loading){
            return <LoadingMain />
        }else if(nodata){
            return <Nodata />
        }else{
            return <>{children}</>
        }
    }
    return (
        <>
            {checkElement()}
        </>
    );
};
export default Loading;
